const NP_BANNER_HIDE_LIFECYCLE_STATUSES = new Set(['scheduled', 'completed'])
const NP_BANNER_HIDE_OPERATIONAL_STATUSES = new Set(['scheduled', 'completed'])

export function consultationDocHidesNpConsultBanner(data: Record<string, unknown>): boolean {
  const lifecycleStatus = data.lifecycleStatus
  if (
    typeof lifecycleStatus === 'string' &&
    NP_BANNER_HIDE_LIFECYCLE_STATUSES.has(lifecycleStatus)
  ) {
    return true
  }
  const operationalStatus = data.operationalStatus
  if (
    typeof operationalStatus === 'string' &&
    NP_BANNER_HIDE_OPERATIONAL_STATUSES.has(operationalStatus)
  ) {
    return true
  }
  return false
}
